import { render, staticRenderFns } from "./AdmAtendimentos.vue?vue&type=template&id=111045f2&"
import script from "./AdmAtendimentos.vue?vue&type=script&lang=js&"
export * from "./AdmAtendimentos.vue?vue&type=script&lang=js&"
import style0 from "./AdmAtendimentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports